module.exports = __webpack_public_path__ + "img/banner-insurance-v2.8b958c27.svg";